import React from "react";

export const Quote = () => {
  return (
    <span className="vsm-quote" />
  );
};
